import type { IApiStore } from '../../../../models/ecommerce/store/storeModel';
import type { StoreContextSettings } from '../slices/store/storeContextSettings';

export const enum DeliveryMode {
    pickup = 'pickup',
    homedelivery = 'homedelivery',
    // oxlint-disable-next-line eslint/no-shadow-restricted-names -- API value named `undefined`, not the global
    undefined = 'undefined',
}

export type StoreState = {
    /** The currently selected store
     * For homedelivery, this is the store fulfilling the order
     * For pickup, this is the store where the pickup point is located
     */
    selectedStore: IApiStore | undefined;
} & StoreContextSettings;
